import AccountsReceivableNumber from '../dto/AccountsReceivableNumber';
import Club from '../dto/Club';
import ClubAccessSettings from '../dto/club/ClubAccessSettings.js';
import Error from '../model/Error';
import InvoiceCount from '../dto/InvoiceCount';
import NumberRangeSettings from '../dto/NumberRangeSettings';
import ParameterValue from '../dto/ParameterValue';
import axios from 'axios';

export default class ClubRepository {

    static getClub(clubId) {
        // there is no "/club/" in url because it is only called by dummy frontend so far
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}`)
                .then(response => resolve(Club.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getNumberRangeSettings(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/number-range-settings`)
                .then(response => resolve(NumberRangeSettings.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateNumberRangeSettings(clubId, numberRangeSettings) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/number-range-settings`, numberRangeSettings)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getNextAccountsReceivableNumber(clubId, accountsReceivableNumberConfig) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/accounts-receivable-number/next`,
                    {
                        accountsReceivableNumberConfig: accountsReceivableNumberConfig.serialize()
                    })
                .then(response => resolve(AccountsReceivableNumber.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getInvoiceCount(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/invoices/count`)
                .then(response => resolve(InvoiceCount.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getAccessSettings(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/access-settings`)
                .then(response => resolve(ClubAccessSettings.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateAccessSettings(clubId, accessSettings) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/access-settings`, accessSettings.serialize())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findAcademicTitles(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/parameter-values/academic-titles`)
                .then(response => resolve(response.data.data.map(data => ParameterValue.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findTerminationReasons(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/parameter-values/termination-reasons`)
                .then(response => resolve(response.data.data.map(data => ParameterValue.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findMemberClassifications(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/parameter-values/member-classifications`)
                .then(response => resolve(response.data.data.map(data => ParameterValue.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findMemberFilterFlags(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/parameter-values/member-filter-flags`)
                .then(response => resolve(response.data.data.map(data => ParameterValue.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findMemberHonors(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/parameter-values/member-honors`)
                .then(response => resolve(response.data.data.map(data => ParameterValue.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findMemberRoles(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/parameter-values/member-roles`)
                .then(response => resolve(response.data.data.map(data => ParameterValue.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findEmployeeRoles(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/clubs/${clubId}/parameter-values/employee-roles`)
                .then(response => resolve(response.data.data.map(data => ParameterValue.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
